export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#0081D3',
    light: '#F1FAFE',
  },
  secondary: {
    main: '#FFFFF',
    contrastText: '#002855',
  },
  text: {
    primary: '#022060',
    light: 'rgba(71, 86, 112, 0.8)',
    secondary: '#5E6C77',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#002060',
    light: '#F3F6F9',
    primary: '#10B7F2',
    paper: '#FFF',
    default: '#FFF',
    hover: '#7ab4ca',
    header: '#26364D',
    footer: '#121721',
    level3: 'linear-gradient(113deg, #01D7FB -11.49%, #027FC7 87.54%)',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#0081D3',
    tableSubhead: '#F7F7F7',
    arrow: '#0081D3',
    tableAlternate: '#F8F8F8',
    alternate: '#E3F1FD',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#002060',
    secondary: '#F8D859',
  },
  verticalBar: {
    used: '#0081D3',
    unused: '#E5F2FA',
    unlimited: '#C0C0C0',
  }
};
